import stockMessage from "../helpers/stockMessage/stockMessage";
import stockMessageInputs from "./stock-status/stockMessageInputs";

const selectWithin = (els, selector) =>
  els.flatMap((el) => [...el.querySelectorAll(selector)]);

class ProductForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("variant:changed", (e) => {
      const { variant } = e.detail;
      console.log(`variant:changed`, e.detail);
      this.variant = variant;
      this.setAction();
      this.updateBadges(variant);
      this.updateQuantityThresholds(variant);
    });

    this.addEventListener("change", (e) => {
      if (!e.target.matches('[name="quantity"]')) return;

      this.setAction();

      const quantityTargets = [
        "stock-status",
        "max-quantity-threshold",
        "product-form-options",
      ];

      quantityTargets.forEach((selector) => {
        const target = this.querySelector(selector);

        if (!target) return;

        target.setAttribute("quantity-requested", e.target.value);
      });
    });

    this.handleCartUpdate = () => this.setAction();
    document.addEventListener("cart:updated", this.handleCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener("cart:updated", this.handleCartUpdate);
  }

  setAction() {
    if (!this.variant) {
      this.showAtc({ disabled: true });
      console.log(`no variant`);
      return;
    }

    this.showActions(this.variant);

    const messages = {
      inStock: {
        action: () => this.showAtc({ disabled: false }),
        properties: {},
      },
      lowStock: {
        action: () => this.showAtc({ disabled: false }),
        properties: {},
      },
      outOfStock: {
        action: () => this.showAtc({ disabled: true, state: "out-of-stock" }),
        properties: {},
      },
      reserveNow: {
        action: () => this.showAtc({ disabled: false }),
        properties: {
          _backordered: "true",
        },
      },
      reserveNowDate: {
        action: () => this.showAtc({ disabled: false }),
        properties: {
          _backordered: "true",
        },
      },
      notifyMe: {
        action: () => this.showNotifyMe(this.variant),
        properties: {},
      },
      notifyMeDate: {
        action: () => this.showNotifyMe(this.variant),
        properties: {},
      },
      madeToOrder: {
        action: () =>
          this.showAtc({ disabled: !this.variant.availableForSale }),
        properties: {
          _made_to_order: "true",
        },
      },
    };

    const { action, properties } = stockMessage({
      ...stockMessageInputs({
        allocatedComponents: window.cartData?.allocatedComponents || {},
        variant: this.variant,
        quantityRequested: this.quantityRequested,
      }),
      messages,
    });

    action();

    // Set this during checkout instead to avoid issues
    // where backorder status gets updated based on qty updates in cart.
    // this.backorderProperties.innerHTML = Object.entries(properties)
    //   .map(
    //     ([property, value]) =>
    //       `<input type="hidden" name="properties[${property}]" value="${value}">`,
    //   )
    //   .join("");
  }

  get quantityRequested() {
    return this.querySelector('[name="quantity"]')?.value || 1;
  }

  showNotifyMe(variant) {
    this.notifyMes.forEach((notifyMe) => {
      notifyMe.setAttribute(
        "url",
        `${variant.product.helpers.url}?variant=${variant.id.replace("gid://shopify/ProductVariant/", "")}`,
      );
      notifyMe.style.display = null;
    });

    this.atcs.forEach((atc) => {
      atc.style.display = "none";
    });
  }

  showAtc({ disabled, state = "add-to-cart" }) {
    this.notifyMes.forEach((notifyMe) => {
      notifyMe.style.display = "none";
    });

    this.atcs.forEach((atc) => {
      atc.dataset.currentState = state;
      atc.style.display = null;
      atc.disabled = disabled;
    });
  }

  showActions(variant) {
    this.actions.forEach((actions) => {
      actions.style.display = JSON.parse(variant.hideOnPdp) ? "none" : null;
    });
  }

  updateBadges(variant) {
    this.badges.forEach((badgeEl) => {
      const badge = variant?.badge || variant?.product?.badge;

      const text = badge?.text || "";
      const color = badge?.color || "#000";

      badgeEl.innerHTML = text;
      badgeEl.style.setProperty("--badge-color", color);
    });
  }

  updateQuantityThresholds(variant) {
    const maxQuantity = variant?.maxQuantityThreshold || "0";
    const quantityInputLimit = parseInt(variant?.maxQuantityThreshold || "99");

    this.maxQuantityThresholds.forEach((el) => {
      el.setAttribute("max-quantity", maxQuantity);
    });

    this.quantityInputs.forEach((el) => {
      el.setAttribute("max", quantityInputLimit);
      el.setAttribute("data-max", quantityInputLimit);

      if (parseInt(el.value) > quantityInputLimit) {
        el.value = quantityInputLimit;
      }
    });
  }

  get atcs() {
    return selectWithin(
      [this, ...this.additionalActions],
      "[data-product-form-atc]",
    );
  }

  get notifyMes() {
    return selectWithin(
      [this, ...this.additionalActions],
      "[data-product-form-notify-me]",
    );
  }

  get badges() {
    return this.querySelectorAll("[data-badge]");
  }

  get actions() {
    return selectWithin(
      [this, ...this.additionalActions],
      "[data-product-form-actions]",
    );
  }

  get maxQuantityThresholds() {
    return this.querySelectorAll("max-quantity-threshold");
  }

  get quantityInputs() {
    return this.querySelectorAll('[name="quantity"]');
  }

  get additionalActions() {
    try {
      return document.querySelectorAll(this.getAttribute("additional-actions"));
    } catch (error) {
      return [];
    }
  }

  // get backorderProperties() {
  //   return this.querySelector("[data-backorder-properties]");
  // }
}

if (!customElements.get("product-form")) {
  customElements.define("product-form", ProductForm);
}
